import appIcon from '../../../application/assets/images/icon.png';

import { LINKS } from '@/lib/constants';
import type { Route } from '@/lib/constants';

interface FooterProps {
  onNavigate: (route: Route) => void;
}

export function Footer({ onNavigate }: FooterProps) {
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="container mx-auto px-5 py-10 flex flex-col md:flex-row gap-6 md:items-center md:justify-between">
        <div className="flex items-center gap-3">
          <img src={appIcon} alt="Michelangelo" className="w-7 h-7 rounded-lg" />
          <div>
            <div className="font-semibold text-white">Michelangelo.land</div>
            <div className="text-xs text-white/50">
              Sculpt your apps fast using natural language.
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <a
            href={LINKS.docs}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
          >
            Docs
          </a>
          <a
            href={LINKS.github}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
          >
            GitHub
          </a>
          <a
            href={LINKS.x}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
          >
            X (Twitter)
          </a>
          <a
            href={LINKS.linkedin}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
          >
            LinkedIn
          </a>
          <a
            href={LINKS.producthunt}
            target="_blank"
            rel="noreferrer"
            className="px-3 py-2 text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
          >
            Product Hunt
          </a>
        </div>
      </div>
      <div className="container mx-auto px-5 pb-6 text-xs text-white/40 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          © {new Date().getFullYear()} Michelangelo.land · Built with taste, shipped with intent.
        </div>
        <div className="flex items-center gap-4">
          <a
            href="/privacy"
            className="hover:text-white transition-colors"
            onClick={(e) => {
              e.preventDefault();
              onNavigate('/privacy');
            }}
          >
            Privacy
          </a>
          <a
            href="/terms"
            className="hover:text-white transition-colors"
            onClick={(e) => {
              e.preventDefault();
              onNavigate('/terms');
            }}
          >
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
}
